module.exports = __webpack_public_path__ + "images/backgrounds/dew/full.1d638bc56d179d5a8c35.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/dew/full.jpg
// module id = eyjb
// module chunks = 2